import React, {useState} from 'react';
import st from './Auth.module.scss';
import {useAuth} from "../../context/context";
import {useNavigate} from "react-router-dom";
import axios from "axios";

const Login = () => {
    const navigate = useNavigate();
    const {login} = useAuth();
    const [loginMode, setLoginMode] = useState(true);
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [email, setEmail] = useState('');
    const [code, setCode] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');

    const API_BASE = process.env.REACT_APP_API_BASE_URL;

    const handleLogin = async (e) => {
        e.preventDefault();
        try {
            const resp = await axios.post(`${API_BASE}auth/login`, {
                username,
                password
            });
            const token = resp.data.token; // Replace with actual token from your API
            login(token);
            navigate("/");
        } catch (error) {
            console.log(error)
        }
    };

    const handleForgotPassword = (e) => {
        e.preventDefault();
        if (newPassword !== confirmPassword) {
            alert('Passwords do not match!');
            return;
        }
        console.log('Resetting password for:', email);
    };

    return (
        <div className={st.container}>
            <form className={st.form} onSubmit={loginMode ? handleLogin : handleForgotPassword}>
                {loginMode ? (
                    <>
                        <h2>Login</h2>
                        <input
                            type="text"
                            placeholder="Username"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            required
                        />
                        <input
                            type="password"
                            placeholder="Password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                        />
                        <button type="submit">Login</button>
                        <p onClick={() => setLoginMode(false)}>Forgot Password?</p>
                    </>
                ) : (
                    <>
                        <h2>Forgot Password</h2>
                        <input
                            type="email"
                            placeholder="Email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                        />
                        <input
                            type="text"
                            placeholder="Code"
                            value={code}
                            onChange={(e) => setCode(e.target.value)}
                            required
                        />
                        <input
                            type="password"
                            placeholder="New Password"
                            value={newPassword}
                            onChange={(e) => setNewPassword(e.target.value)}
                            required
                        />
                        <input
                            type="password"
                            placeholder="Confirm Password"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            required
                        />
                        <button type="submit">Reset Password</button>
                        <p onClick={() => setLoginMode(true)}>Back to Login</p>
                    </>
                )}
            </form>
        </div>
    );
};

export default Login;
